export enum EAddDeviceValidationType {
    Valid,
    InvalidRegistrationCode,
    AlreadyUsedRegistrationCode,
    ApprovedIVRPhoneHasNotJob,
}
